export let minConfidence = 0.2;
export let inputSize = 96;
export let scoreThreshold = 0.3;

export async function loadApis(faceapi) {
  // load face detection, face landmark model and face recognition models
  console.log(" loading face detector api");
  console.log(faceapi?.tf?.getBackend());

  // default is webgl backend
  await faceapi.tf.setBackend("webgl");

  await faceapi.tf.enableProdMode();
  await faceapi.tf.ENV.set("DEBUG", false);
  await faceapi.tf.ready();
  return await faceapi.nets.tinyFaceDetector.loadFromUri("/model");
  // return await faceapi.nets.ssdMobilenetv1.loadFromUri("/model");
}

export function isFaceDetectionModelLoaded(faceapi) {
  return !!faceapi.nets.tinyFaceDetector.params;
  // return !!faceapi.nets.ssdMobilenetv1.params;
}

export const tinydetectorOptions = (faceapi) =>
  // new faceapi.SsdMobilenetv1Options({ minConfidence });
  new faceapi.TinyFaceDetectorOptions({ inputSize, scoreThreshold });

export function drawBox(box, context) {
  // context.beginPath();
  context.lineWidth = 4;
  context.strokeStyle = "green";
  // context.lineJoin = "square";
  //context.strokeRect(box.x, box.y, box.width,box.height);
  //console.log(box.rescale({width,height}));
  // context.strokeRect(box.x, box.y, box.width, box.height);
  // context.lineWidth = 4;
  // context.strokeStyle = "deepskyblue";
  // context.fillStyle = "deepskyblue";
  context.globalAlpha = 0.6;
  context.beginPath();
  context.rect(box.x, box.y, box.width, box.height);
  context.stroke();
  context.globalAlpha = 1;
}

export const getDisplaySize = (videoEl) => {
  let width = 440;
  let height = videoEl.videoHeight / (videoEl.videoWidth / width);
  //addressing firefox video size issue
  if (isNaN(height)) {
    height = videoEl.width / (4 / 3);
  }
  return { width: videoEl.width, height: height };
};

export const videoSnaphotToBlob = (videoEl, displaySize) => {
  let canvas2 = document.createElement("canvas");
  canvas2.width = displaySize.width;
  canvas2.height = displaySize.height;
  let context2 = canvas2.getContext("2d");
  // copy image to it (this method allows to cut image)
  context2.drawImage(videoEl, 0, 0, displaySize.width, displaySize.height);

  //pause video to make user aware that you have taken a snapshot
  videoEl.pause();

  //show loading state
  /*
    spinner.classList.add('show')
      **/
  return new Promise(function (resolve, reject) {
    canvas2.toBlob(function (blob) {
      resolve(blob);
    }, "image/png");
  });
};
